import React from 'react'
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { ReportGroup } from '../../../generated'

interface ReportGroupSelectProps {
  value: string
  onChange: (value: string) => void
  reportTemplates: (ReportGroup | null)[]
}

export const ReportGroupSelect: React.FC<ReportGroupSelectProps> = ({ reportTemplates, value, onChange }) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value)
  }

  return (
    <FormControl fullWidth>
      <InputLabel>Report Group</InputLabel>
      <Select
        value={value}
        label="Report Group"
        onChange={handleChange}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E0E0E0'
          }
        }}
      >
        {reportTemplates?.map(group => (
          <MenuItem key={group?.group} value={group?.group}>
            {group?.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
